import _asyncToGenerator from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.concat.js";
import Head from "@/components/Head/index.vue";
import Tabs from "@/components/Tabs/index.vue";
import useCurrentInstance from "@/hooks/useCurrentInstance";
import { defineComponent, ref, watch, nextTick, onActivated } from "vue";
import List from "./components/List.vue";
export default defineComponent({
  name: "Mission",
  components: {
    Tabs: Tabs,
    Head: Head,
    List: List
  },
  setup: function setup() {
    var _useCurrentInstance = useCurrentInstance(),
        globalProperties = _useCurrentInstance.globalProperties; //tabs名称


    var titleArr = ["待开始", "已结束"]; //tabs状态值

    var tabsIndex = ref(0); // tabs状态切换

    function changeOther(val) {
      tabsIndex.value = val;
    } // list组件对象


    var table1 = ref();
    var table2 = ref(); // 当前待开始的数量

    var totalNum = ref(0); // 分类

    var options = ref([]); // 分类值

    var typeValue = ref(1); // 获取分类列表

    function getTask() {
      return _getTask.apply(this, arguments);
    }

    function _getTask() {
      _getTask = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var ref;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getEffectiveType"]();

              case 2:
                ref = _context.sent;

                if (ref.data && ref.code == 0) {
                  options.value = options.value.concat(ref.data);
                }

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _getTask.apply(this, arguments);
    }

    getTask(); // 分类选择

    function selectChange(val) {
      totalNum.value = 0;
      typeValue.value = val;
    }

    function getList() {
      nextTick(function () {
        if (tabsIndex.value == 0) {
          table1.value.getList();
        } else {
          table2.value.getList();
        }
      });
    } // // 监听tabs索引值改变


    watch(function () {
      return tabsIndex.value;
    }, function () {
      getList();
    });
    watch(function () {
      return typeValue.value;
    }, function () {
      nextTick(function () {
        table1.value.getList();
        table2.value.getList();
      });
    }); //刷新列表

    onActivated(function () {
      getList();
    });
    return {
      titleArr: titleArr,
      options: options,
      typeValue: typeValue,
      tabsIndex: tabsIndex,
      table1: table1,
      table2: table2,
      totalNum: totalNum,
      selectChange: selectChange,
      changeOther: changeOther
    };
  }
});